module.exports = __webpack_public_path__ + "img/画板 2.64dd7b5b.png";